import List from './views/List.vue'

export const CountryRoutes = [
  {
    path: '/countries',
    name: 'ListCountries',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'country:list'
    }
  }
]
